import GoogleMap from "../map/google-map-sites-location";
// import GoogleMap from "../map/google-map-component";
import { useSelector } from "react-redux";
import { AppState } from "../../../../store/store";

const SitesLocationMap = (props: any) => {
  const { setMapPopupInput, mapData, setMapData } = props;
  const ResizeStoreToSetHeight = useSelector(
    (state: AppState) => state.AuraCameraCommon.setMapHeightPanel
  );

  return (
    <>
      <GoogleMap
        lati={-31.56391}
        lon={147.154312}
        setMapPopupInput={setMapPopupInput}
        mapData={mapData}
        setMapData={setMapData}
        height={ResizeStoreToSetHeight}
      />
    </>
  );
};

export default SitesLocationMap;
